import axios from "@/libs/axios";

export default {
  loadTable(queryFilter) {
    let queryUrl = "";
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${
      queryFilter.sort
    },${queryFilter.order}`;
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`;
    }
    return axios.get(`evento/evento_responsaveis${queryUrl}`);
  },
  insertNew(data) {
    return axios.post("evento/evento_responsaveis", data);
  },
  edit(data) {
    return axios.put(`evento/evento_responsaveis/${data.id}`, data);
  },
  delete(id) {
    return axios.delete(`evento/evento_responsaveis/${id}`);
  },
};
